export function saveDataListState(
  page,
  searchTerm,
  filter,
  pageSize,
  sortList
) {
  if (!history.pushState) {
    return;
  }
  const search = searchTerm ? `&searchTerm=${searchTerm || ""}` : "";
  const manager =
    filter && filter.manager && filter.manager.id
      ? `&managerId=${filter.manager.id}`
      : "";
  const analyst =
    filter && filter.analyst && filter.analyst.id
      ? `&analystId=${filter.analyst.id}`
      : "";
  const dateFrom =
    filter && filter.dateFrom ? `&dateFrom=${filter.dateFrom}` : "";
  const dateTo = filter && filter.dateTo ? `&dateTo=${filter.dateTo}` : "";
  const paymentType =
    filter && filter.paymentType && filter.paymentType.id
      ? `&paymentTypeId=${filter.paymentType.id}`
      : "";
  const paymentSource =
    filter && filter.paymentSource && filter.paymentSource.id
      ? `&paymentSourceId=${filter.paymentSource.id}`
      : "";
  const itemsPerPage = pageSize ? `&pageSize=${pageSize}` : "";
  const serviceType =
    filter && filter.serviceType && filter.serviceType.id
      ? `&serviceTypeId=${filter.serviceType.id}`
      : "";
  const saleOption =
    filter && filter.saleOption ? `&saleOption=${filter.saleOption}` : "";
  const invoicePaymentStatus =
    filter && filter.invoicePaymentStatus
      ? `&invoicePaymentStatus=${filter.invoicePaymentStatus}`
      : "";
  const product =
    filter && filter.product && filter.product.id
      ? `&productId=${filter.product.id}`
      : "";
  const service =
    filter && filter.service && filter.service.id
      ? `&serviceId=${filter.service.id}`
      : "";

  let sortParams = "";
  if (sortList) {
    sortList.forEach((item, index) => {
      sortParams += `&order.${item.name}.isDesc=${item.isDesc}&order.${
        item.name
      }.order=${index + 1}`;
    });
  }

  // eslint-disable-next-line max-len
  const newurl = `${window.location.pathname}?page=${page}${itemsPerPage}${search}${manager}${analyst}${dateFrom}${dateTo}${paymentType}${paymentSource}${serviceType}${saleOption}${invoicePaymentStatus}${product}${service}${sortParams}`;

  window.history.pushState({ path: newurl }, "", newurl);
}
